export enum RewardJourneyType {
  SUBMIT_METER_READING = 'SUBMIT_METER_READING',
  APPLY_FOR_METER = 'APPLY_FOR_METER',
  SWITCH_TO_MEASURED = 'SWITCH_TO_MEASURED',
  MOVE_IN = 'MOVE_IN',
  REGISTER = 'REGISTER',
}

export enum RewardBrand {
  COSTA = 'COSTA',
  GREGGS = 'GREGGS',

  ACCOUNT_CREDIT = 'ACCOUNT_CREDIT',
}

export type RewardJourneyParams = {
  journey: RewardJourneyType;
  brand?: RewardBrand;
  timestamp?: string;
};

export const REWARD_JOURNEY_SESSION_KEY = 'reward_journey_completed';
